import type { ReactNode } from 'react';

import { useFelaEnhanced } from '@/hooks';
import type { RulesExtend } from '@/styles/theme';

import * as felaRules from './AlertContainer.rules';

export interface AlertContainerProps {
    extend?: RulesExtend<typeof felaRules>;
    children: ReactNode;
}

export const AlertContainer = ({ extend, children }: AlertContainerProps) => {
    const { styles } = useFelaEnhanced(felaRules, { extend });

    return (
        <div className={styles.container}>
            <div className={styles.overlay} />
            {children}
        </div>
    );
};
